"use client"

import { useEffect, useState } from "react"
import { useRouter } from "next/navigation"
import { adminLogin } from "@/lib/api"
import { useAuth } from "@/store/auth"

export default function LoginPage() {
  const router = useRouter()
  const { accessToken, setSession } = useAuth()
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [showPwd, setShowPwd] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  useEffect(() => {
    if (accessToken) router.replace("/blog_admin/posts")
  }, [accessToken, router])

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError("")
    setLoading(true)
    try {
      const r = await adminLogin(username, password)
      setSession({
        accessToken: r.access_token,
        refreshToken: r.refresh_token,
        role: r.role,
        username,
      })
      router.replace("/blog_admin/posts")
    } catch (err) {
      setError(err instanceof Error ? err.message : "登录失败")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-[80vh] items-center justify-center px-4">
      <div className="w-full max-w-sm space-y-6 rounded-3xl bg-white px-8 py-8" style={{boxShadow: "8px 8px 16px rgba(0,0,0,0.12), -4px -4px 12px rgba(255,255,255,0.8), inset 2px 2px 6px rgba(255,255,255,0.6), inset -2px -2px 6px rgba(0,0,0,0.06)"}}>
        <div>
          <h1 className="text-xl font-bold text-gray-800">后台登录</h1>
          <p className="text-sm text-gray-400 mt-1">马小哈希博客管理</p>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <label className="block space-y-1.5">
            <span className="text-sm text-gray-500">用户名</span>
            <input
              className="h-10 w-full rounded-2xl border-0 bg-gray-50 px-4 text-sm outline-none focus:ring-2 focus:ring-sky-200 transition-all"
              style={{boxShadow: "inset 2px 2px 5px rgba(0,0,0,0.08), inset -1px -1px 4px rgba(255,255,255,0.9)"}}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus
              autoComplete="username"
              required
            />
          </label>
          <label className="block space-y-1.5">
            <span className="text-sm text-gray-500">密码</span>
            <div className="relative">
              <input
                type={showPwd ? "text" : "password"}
                className="h-10 w-full rounded-2xl border-0 bg-gray-50 px-4 pr-10 text-sm outline-none focus:ring-2 focus:ring-sky-200 transition-all"
                style={{boxShadow: "inset 2px 2px 5px rgba(0,0,0,0.08), inset -1px -1px 4px rgba(255,255,255,0.9)"}}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
              <button type="button" onClick={() => setShowPwd(s => !s)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-xs">
                {showPwd ? "隐" : "显"}
              </button>
            </div>
          </label>
          {error && (
            <div className="rounded-2xl bg-red-50 px-4 py-2 text-sm text-red-400">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="h-10 w-full rounded-2xl bg-gradient-to-r from-sky-500 to-cyan-500 text-sm font-semibold text-white transition-opacity hover:opacity-90 disabled:opacity-50"
            style={{boxShadow: "4px 4px 10px rgba(0,0,0,0.10), -2px -2px 8px rgba(255,255,255,0.8)"}}
          >
            {loading ? "登录中..." : "登录"}
          </button>
        </form>
      </div>
    </div>
  )
}
